import type { Ref } from 'react';
import React, { forwardRef } from 'react';

import { MenuItem, Typography } from '@mui/material';
import type { HandlerFunction } from 'src/types/general';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  iconWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
  },
  option: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    paddingBottom: theme.spacing(0.75),
    paddingTop: theme.spacing(0.75),
  },
  optionTextWithIcon: {
    marginLeft: theme.spacing(1.5),
  },
}));

interface OptionsMenuItemProps {
  clickHandler: HandlerFunction;
  text: string;
  dataCy?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

export const OptionsMenuItem = forwardRef(function OptionsMenuItem(
  { clickHandler, dataCy, disabled, icon, text }: OptionsMenuItemProps,
  ref: Ref<HTMLLIElement>
): JSX.Element {
  const { classes } = useStyles();

  return (
    <MenuItem
      ref={ref}
      className={classes.option}
      data-cy={dataCy}
      disabled={disabled}
      onClick={clickHandler}
    >
      {icon ? <span className={classes.iconWrapper}>{icon}</span> : null}
      <Typography className={icon ? classes.optionTextWithIcon : undefined} variant="body1">
        {text}
      </Typography>
    </MenuItem>
  );
});
